// extracted by mini-css-extract-plugin
export default {"inputDisabled":"DBTextField_inputDisabled__hdNks"};